import { IRegion } from './../../../../_models/account/IRegion';
import { RegionService } from './../../../../shared/services/region.service';
import { ISanctionedPost } from './../../../../_models/post-sections/ISanctionedPost';
import { IKeyValuePair } from './../../../../_models/common/common';
import { CommonService } from './../../../../shared/services/common.service';
import { SanctionedPostService } from './../../../../shared/services/sanctioned-post.service';
import { ToastrService } from 'ngx-toastr';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SettingService } from 'src/app/shared/services/setting.service';
import { ISetting } from 'src/app/_models/cms/ISetting';

@Component({
  selector: 'app-sanctioned-post-form',
  templateUrl: './sanctioned-post-form.component.html'
})
export class SanctionedPostFormComponent implements OnInit {

  loading: boolean;
  title: string = 'Add Sanctioned Post';
  region: IRegion;
  setting: ISetting;
  sanctionedPost: ISanctionedPost;
  sanctionedPostForm: FormGroup;
  id;

  schoolLevels: IKeyValuePair[];
  regions: IKeyValuePair[];
  states: IKeyValuePair[];
  districts: IKeyValuePair[];
  schools: IKeyValuePair[];
  designations: IKeyValuePair[];

  constructor(private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private toastrService: ToastrService,
    private service: SanctionedPostService,
    private regionService: RegionService,
    private commonService: CommonService,
    private settingService: SettingService) {
    this.id = this.route.snapshot.paramMap.get('id');
    this.settingService.getSetting().then((data: ISetting) => {
      this.setting = data;
      if (!this.setting.isVacancyRO) {
        this.toastrService.warning("vacancy module closed!");
        this.router.navigate(['/']);
      }
      console.log('Promise resolved.');
    });
  }

  ngOnInit() {
    this.bindDropDown();
    this.createSanctionedPostForm();
    this.regionService.logged().subscribe((response: IRegion) => {
      if (response) {
        this.region = response;
        this.sanctionedPostForm.patchValue({
          regionId: this.region.userId
        });
        this.getStates(this.region.userId);
        this.getSanctionedPost();
      }
    });
  }

  getSanctionedPost() {
    if (this.id) this.service.get(this.id).subscribe((response: ISanctionedPost) => {
      if (response) {
        this.sanctionedPost = response;
        this.title = 'Edit Sanctioned Post';
        this.setValueSanctionedPostForm();
      }
    });
  }

  bindDropDown() {
    this.commonService.getDesignations().subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.designations = response;
      }
    });
  }

  getStates(regionId: string) {
    this.commonService.getStates(regionId).subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.states = response;
      }
    });
  }

  getDistricts(stateId: number) {
    this.commonService.getDistricts(stateId).subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.districts = response;
      }
    });
  }

  getSchools(districtId: number, schoolLevelId?: number) {
    this.commonService.getSchools(districtId, schoolLevelId).subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.schools = response;
      }
    });
  }

  createSanctionedPostForm() {
    this.sanctionedPostForm = this.fb.group({
      id: ['0'],
      schoolLevelId: ['1', Validators.required],
      regionId: [''],
      stateId: [''],
      districtId: [''],
      schoolId: ['', Validators.required],
      designationId: ['', Validators.required],
      noOfPost: ['0', Validators.required],
      isActive: [true, Validators.required]
    });
  }

  setValueSanctionedPostForm() {
    if (this.sanctionedPost.school.stateId) {
      this.getDistricts(this.sanctionedPost.school.stateId);
    }

    if (this.sanctionedPost.school.districtId) {
      this.getSchools(this.sanctionedPost.school.districtId, this.sanctionedPost.school.schoolLevelId);
    }

    this.sanctionedPostForm.patchValue({
      id: this.sanctionedPost.id,
      schoolLevelId: this.sanctionedPost.school.schoolLevelId,
      regionId: this.sanctionedPost.school.regionId,
      stateId: this.sanctionedPost.school.stateId,
      districtId: this.sanctionedPost.school.districtId,
      schoolId: this.sanctionedPost.schoolId,
      designationId: this.sanctionedPost.designationId,
      noOfPost: this.sanctionedPost.noOfPost,
      isActive: this.sanctionedPost.isActive
    });
  }

  save() {
    if (this.sanctionedPostForm.valid) {
      this.loading = true;
      this.sanctionedPost = Object.assign({}, this.sanctionedPostForm.value);
      if (this.id) {
        this.service.update(this.id, this.sanctionedPost).subscribe(() => {
          this.toastrService.success('sanctioned post updated successful');
          this.router.navigate(['/region/sanctioned-posts']);
        },
          (error) => console.log('HTTP Error', error),
          () => this.loading = false);
      }
      else {
        this.service.create(this.sanctionedPost).subscribe(() => {
          this.toastrService.success('sanctioned post created successful');
          this.router.navigate(['/region/sanctioned-posts']);
        },
          (error) => console.log('HTTP Error', error),
          () => this.loading = false);
      }
    }
  }


}
